<script>
    export let label = "";
    export let value = "";
</script>

<div style="display: flex; justify-content: space-between"><div>{label}</div><div style="flex-grow: 1">{value}</div></div>
